import { render } from "./AboutSlider.vue?vue&type=template&id=442abfba&scoped=true"
import script from "./AboutSlider.vue?vue&type=script&lang=js"
export * from "./AboutSlider.vue?vue&type=script&lang=js"

import "./AboutSlider.vue?vue&type=style&index=0&id=442abfba&scoped=true&lan=scss&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442abfba"]])

export default __exports__